(function () {
  'use strict';

  function formatCurrency(value) {
    if (value == null || value === '') return 'R$ 0,00';
    const raw = typeof value === 'number' ? String(value) : String(value).trim();
    const num = Number(raw.replace(',', '.'));
    if (!isFinite(num)) return String(value);
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }

  function extractDeliveryFromText(text) {
    if (!text) return null;
    const patterns = [
      { regex: /(\d+)\s*(?:a|à|-)\s*(\d+)\s*dias?\s*(?:úteis?|uteis?)/i, fmt: (m) => `${m[1]}-${m[2]} dias úteis` },
      { regex: /(\d+)\s*dias?\s*(?:úteis?|uteis?)/i, fmt: (m) => (parseInt(m[1], 10) === 1 ? '1 dia útil' : `${m[1]} dias úteis`) },
      { regex: /(\d+)\s*(?:a|à|-)\s*(\d+)\s*dias?/i, fmt: (m) => `${m[1]}-${m[2]} dias` },
      { regex: /(\d+)\s*dias?/i, fmt: (m) => (parseInt(m[1], 10) === 1 ? '1 dia' : `${m[1]} dias`) },
    ];
    for (const p of patterns) {
      const m = String(text).match(p.regex);
      if (m) return p.fmt(m);
    }
    return null;
  }

  function formatDeliveryDaysArray(deliveryDays) {
    if (!Array.isArray(deliveryDays) || !deliveryDays.length) return '';
    const last = deliveryDays[deliveryDays.length - 1];
    return last === 1 ? '1 dia útil' : `${last} dias úteis`;
  }

  function computeDeliveryTime(rate) {
    const deliveryRange = rate.delivery_range ? String(rate.delivery_range).trim() : '';
    const deliveryDate = rate.delivery_date ? String(rate.delivery_date).trim() : '';
    if (deliveryRange && deliveryRange !== 'null' && deliveryRange !== 'undefined') {
      if (deliveryRange.includes(',') && deliveryRange.includes('-')) {
        const [startDate, endDate] = deliveryRange.split(',').map((s) => s.trim());
        try {
          const start = new Date(startDate);
          const end = new Date(endDate);
          const today = new Date();
          const diffStart = Math.ceil((start - today) / 86400000);
          if (diffStart <= 0) return 'Entrega hoje';
          if (diffStart === 1) return '1 dia útil';
          if (startDate === endDate) return `${diffStart} dias úteis`;
          const diffEnd = Math.ceil((end - today) / 86400000);
          return `${diffStart} a ${diffEnd} dias úteis`;
        } catch {
          return deliveryRange;
        }
      }
      return deliveryRange;
    }
    if (deliveryDate && deliveryDate !== 'null' && deliveryDate !== 'undefined') return deliveryDate;
    if (rate.delivery_estimate_business_days && rate.delivery_estimate_business_days !== 'undefined') {
      const d = parseInt(rate.delivery_estimate_business_days, 10);
      if (d > 0) return d === 1 ? '1 dia útil' : `${d} dias úteis`;
    }
    if (rate.delivery_estimate_transit_time_business_days && rate.delivery_estimate_transit_time_business_days !== 'undefined') {
      const d = parseInt(rate.delivery_estimate_transit_time_business_days, 10);
      if (d > 0) return d === 1 ? '1 dia útil' : `${d} dias úteis`;
    }
    if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      return formatDeliveryDaysArray(rate.delivery_days);
    }
    if (rate.description && rate.description.trim() !== '') {
      return extractDeliveryFromText(rate.description.trim()) || rate.description.trim();
    }
    return extractDeliveryFromText(rate.name) || '';
  }

  function getProductForm(wrapper) {
    const formId = wrapper.dataset.productFormId;
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId) return byId;
    }
    const sectionId = wrapper.dataset.sectionId;
    if (sectionId) {
      const sectionForm = document.getElementById(`product-form-${sectionId}`);
      if (sectionForm) return sectionForm;
    }
    return (
      document.querySelector('product-form.m-product-form--main form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]')
    );
  }

  function getProductFormData(wrapper) {
    const form = getProductForm(wrapper);
    if (!form) return null;
    const fd = new FormData(form);
    const variantId = fd.get('id');
    const quantity = fd.get('quantity') || 1;
    const obj = { id: variantId, quantity: Number(quantity) || 1 };
    const properties = {};
    fd.forEach((v, k) => {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) properties[m[1]] = v;
    });
    if (Object.keys(properties).length) obj.properties = properties;
    const sellingPlan = fd.get('selling_plan');
    if (sellingPlan) obj.selling_plan = sellingPlan;
    return obj.id ? obj : null;
  }

  async function backupCart() {
    const resp = await fetch('/cart.js', { method: 'GET' });
    const cart = await resp.json();
    return (cart.items || []).map((it) => ({
      id: it.variant_id,
      quantity: it.quantity,
      properties: it.properties && Object.keys(it.properties).length ? it.properties : undefined,
      selling_plan: it.selling_plan_allocation?.selling_plan?.id || undefined,
    }));
  }

  async function restoreCart(items) {
    await fetch('/cart/clear.js', { method: 'POST' });
    if (items && items.length) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: items.map((i) => {
            const out = { id: i.id, quantity: i.quantity };
            if (i.properties) out.properties = i.properties;
            if (i.selling_plan) out.selling_plan = i.selling_plan;
            return out;
          }),
        }),
      });
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  async function addTemporaryLine(item) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(item),
    });
  }

  function hideAllFreteAlerts(wrapper) {
    if (!wrapper) return;
    wrapper.querySelectorAll('[data-frete-danger], [data-frete-aviso], [data-frete-sucesso]').forEach((el) => {
      el.innerHTML = '';
      el.setAttribute('hidden', '');
    });
  }

  function showFreteMessage(wrapper, kind, message) {
    hideAllFreteAlerts(wrapper);
    const map = {
      danger: '[data-frete-danger]',
      warning: '[data-frete-aviso]',
      success: '[data-frete-sucesso]',
    };
    const el = wrapper.querySelector(map[kind]);
    if (!el) return;
    el.innerHTML = `<p class="jv-estimativa-frete__msg">${message}</p>`;
    el.removeAttribute('hidden');
  }

  function renderRates(ratesData, wrapper) {
    hideAllFreteAlerts(wrapper);
    const elSucesso = wrapper.querySelector('[data-frete-sucesso]');
    const elAviso = wrapper.querySelector('[data-frete-aviso]');
    if (!ratesData || !ratesData.shipping_rates || !ratesData.shipping_rates.length) {
      if (elAviso) {
        elAviso.innerHTML = '<p class="jv-estimativa-frete__msg">Não foi possível encontrar opções de frete para o CEP informado.</p>';
        elAviso.removeAttribute('hidden');
      }
      return;
    }
    let html = '';
    ratesData.shipping_rates.forEach((rate) => {
      const priceText =
        Number(rate.price) === 0
          ? '<span class="jv-estimativa-frete__gratis">GRÁTIS</span>'
          : formatCurrency(rate.price);
      const delivery = computeDeliveryTime(rate);
      html += `<div class="jv-estimativa-frete__shipping-option"><div class="jv-estimativa-frete__shipping-header"><div class="jv-estimativa-frete__shipping-name">${rate.name}</div><div class="jv-estimativa-frete__shipping-price">${priceText}</div></div>${delivery ? `<div class="jv-estimativa-frete__shipping-delivery">${delivery}</div>` : ''}</div>`;
    });
    if (elSucesso) {
      elSucesso.innerHTML = html;
      elSucesso.removeAttribute('hidden');
    }
  }

  async function tryAlternativeMethod(zip, country, province, wrapper) {
    const form = new URLSearchParams();
    form.append('shipping_address[zip]', zip);
    form.append('shipping_address[country]', country);
    form.append('shipping_address[province]', province);
    const prep = await fetch('/cart/prepare_shipping_rates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: form,
    });
    if (!prep.ok) throw new Error('Prepare failed');
    for (let i = 0; i < 10; i++) {
      await new Promise((r) => setTimeout(r, 1000));
      const r = await fetch('/cart/async_shipping_rates', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (r.status === 200) {
        const json = await r.json();
        if (json && json.shipping_rates && json.shipping_rates.length) {
          renderRates(json, wrapper);
          return;
        }
      }
    }
    throw new Error('Timeout polling');
  }

  async function calculateRates(zip, country, province, wrapper) {
    const url = `/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`;
    try {
      const r = await fetch(url, {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' },
      });
      if (!r.ok) throw new Error('fallback');
      const text = await r.text();
      let json;
      try {
        json = JSON.parse(text);
      } catch {
        throw new Error('Resposta inválida');
      }
      renderRates(json, wrapper);
    } catch {
      await tryAlternativeMethod(zip, country, province, wrapper);
    }
  }

  function clearAlerts(wrapper) {
    wrapper.querySelectorAll('[data-frete-danger], [data-frete-aviso], [data-frete-sucesso]').forEach((el) => {
      el.innerHTML = '';
      el.setAttribute('hidden', 'hidden');
    });
  }

  async function generateShippingRates(btn) {
    const wrapper = btn?.closest?.('[data-jv-estimativa-frete]');
    if (!wrapper) return;

    const zipInput = wrapper.querySelector('[data-frete-cep]');
    const zip = (zipInput?.value || '').trim();
    const elDanger = wrapper.querySelector('[data-frete-danger]');
    const elAviso = wrapper.querySelector('[data-frete-aviso]');
    const elSucesso = wrapper.querySelector('[data-frete-sucesso]');

    clearAlerts(wrapper);

    const originalContent = btn.innerHTML;
    const calculatingLabel = wrapper.dataset.calculatingLabel || 'Calculando...';
    btn.disabled = true;
    btn.innerHTML = calculatingLabel;

    const cepUnmasked = zip.replace(/\D/g, '');
    const cepRegex = /^[0-9]{8}$/;

    if (!cepRegex.test(cepUnmasked)) {
      if (elAviso) {
        elAviso.innerHTML = '<p class="jv-estimativa-frete__msg">Formato de CEP inválido.</p>';
        elAviso.removeAttribute('hidden');
      }
      btn.innerHTML = originalContent;
      btn.disabled = false;
      return;
    }

    const country = 'BR';
    let province = 'BR';
    let backup = null;

    try {
      try {
        const respCep = await fetch(`https://brasilapi.com.br/api/cep/v1/${cepUnmasked}`);
        if (respCep.ok) {
          const data = await respCep.json();
          province = data.state || 'BR';
        }
      } catch (_) {}

      backup = await backupCart();
      const productItem = getProductFormData(wrapper);

      if (!productItem) {
        if (elAviso) {
          elAviso.innerHTML = '<p class="jv-estimativa-frete__msg">Não foi possível detectar o produto/variante atual.</p>';
          elAviso.removeAttribute('hidden');
        }
        btn.innerHTML = originalContent;
        btn.disabled = false;
        return;
      }

      await fetch('/cart/clear.js', { method: 'POST' });
      await addTemporaryLine(productItem);
      await calculateRates(cepUnmasked, country, province, wrapper);
      await restoreCart(backup);
      backup = null;
    } catch (e) {
      if (elAviso) {
        elAviso.innerHTML = '<p class="jv-estimativa-frete__msg">Erro ao calcular frete. Tente novamente.</p>';
        elAviso.removeAttribute('hidden');
      }
      if (backup) {
        try {
          await restoreCart(backup);
        } catch (_) {}
      }
    } finally {
      btn.innerHTML = originalContent;
      btn.disabled = false;
    }
  }

  function bindWrapper(wrapper) {
    const zipInput = wrapper.querySelector('[data-frete-cep]');
    const btn = wrapper.querySelector('[data-frete-btn]');
    if (!zipInput || !btn || wrapper.dataset.freteBound === '1') return;
    wrapper.dataset.freteBound = '1';

    zipInput.addEventListener('input', function (e) {
      const v = e.target.value.replace(/\D/g, '');
      e.target.value = v.length > 5 ? `${v.slice(0, 5)}-${v.slice(5, 8)}` : v;
    });

    zipInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (!btn.disabled) generateShippingRates(btn);
      }
    });

    btn.addEventListener('click', function () {
      if (!btn.disabled) generateShippingRates(btn);
    });
  }

  function init(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-jv-estimativa-frete]').forEach(bindWrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) init(event.target);
  });

  window.JvEstimativaFrete = {
    formatCurrency,
    computeDeliveryTime,
    hideAllFreteAlerts,
    showFreteMessage,
    renderRates,
  };
})();
